import { mountApplications } from '~/wikis/edit';
import { mountWikiSidebar } from '~/wikis/mount_sidebar';
import { mountMoreActions } from '~/wikis/more_actions';

mountApplications();
mountWikiSidebar();
mountMoreActions();
